var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('item-content',{attrs:{"item":_vm.item}}),_c('delete-item-action',{attrs:{"item":_vm.item},on:{"removeItem":function($event){return _vm.$emit('removeItem', _vm.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }